import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers';
import * as version from '../../../utils/version';
import Accordion from '../../Accordion';
import { Translate } from 'react-redux-i18n';
import Utils from '../../../utils';
import UserAgentUtils from '../../../utils/userAgent';
import NativeApiUtils from '../../../utils/nativeApi';
import { setUsedSpace, setFreeSpace } from '../../../containers/ParametersPage/actions';
import { InfosFields } from '../styles';

interface AppInfosProps {
	dispatch: Dispatch<StoreState>;
	usedSpace: string;
	freeSpace: string;
}

class AppInfos extends React.Component<AppInfosProps, {}> {
	constructor(props: AppInfosProps) {
		super(props);

		if (UserAgentUtils.isMobileApp) {
			this.setAppSpaceInfos();
		}
	}

	setAppSpaceInfos() {
		const { dispatch } = this.props;

		NativeApiUtils.getUsedSpace().then(
			value => {
				dispatch(setUsedSpace(Utils.formatFileSize(value)));
			}
		);

		NativeApiUtils.getFreeSpace().then(
			value => {
				dispatch(setFreeSpace(Utils.formatFileSize(value)));
			}
		);
	}

	render() {
		const { freeSpace, usedSpace } = this.props;

		return (
			<Accordion
				title="messages.my_app"
				isOpened={true}
			>
				{UserAgentUtils.isMobileApp &&
					<>
						<InfosFields
							key="usedSpace"
						>
							<Translate value="messages.used_space" />
							{usedSpace}
						</InfosFields>
						<InfosFields
							key="freeSpace"
						>
							<Translate value="messages.free_space" />
							{freeSpace}
						</InfosFields>
					</>
				}
				<InfosFields
					key="version"
				>
					<Translate value="messages.version" />
					{version}
				</InfosFields>
			</Accordion>
		);
	}
}

export default AppInfos;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ParametersPage/AppInfos/index.tsx